'use client';

import { useEffect, useState } from 'react';

import { Image } from '@/components/atoms';
import { HeroBanner } from '@/components/molecules/Hero';
import { cn } from '@/lib/utils/tailwind';
import { getRandomDefaultImage } from '@/lib/utils/getRandomImage';

import type { ResponsiveBannerProps } from './types';
import type { Breakpoint } from '@/components/atoms';

const HERO_BREAKPOINTS: Breakpoint[] = [
  [640, 640],
  [1024, 1024],
  [1440, 1440],
  [1920, 1920],
];

export const ResponsiveBanner = ({
  banner,
  fallbackUrl,
  alt,
}: ResponsiveBannerProps) => {
  const [placeholder, setPlaceholder] = useState<string | undefined>(undefined);

  useEffect(() => {
    setPlaceholder(getRandomDefaultImage('video'));
  }, []);

  const landscapeSrc = banner?.landscape?.url || fallbackUrl || placeholder;
  const portraitSrc =
    banner?.portrait?.url ||
    banner?.landscape?.url ||
    fallbackUrl ||
    placeholder;

  return (
    <HeroBanner
      as="header"
      className={cn(
        'relative',
        'aspect-[4/5] sm:aspect-video sm:max-h-[85vh] sm:max-w-[1440px]',
        'sm:mx-auto',
        'overflow-hidden',
        'bg-[var(--hero-gradient)]',
      )}
      media={
        <>
          {landscapeSrc && (
            <Image
              src={landscapeSrc}
              alt={alt}
              breakpoints={HERO_BREAKPOINTS}
              className="object-cover rounded-none"
              wrapperClassName="rounded-none hidden sm:block"
              priority
            />
          )}
          {portraitSrc && (
            <Image
              src={portraitSrc}
              alt={alt}
              breakpoints={HERO_BREAKPOINTS}
              className="object-cover rounded-none"
              wrapperClassName="rounded-none sm:hidden"
              priority
            />
          )}
          <div
            className="absolute inset-0 bg-gradient-hero pointer-events-none"
            aria-hidden
          />
        </>
      }
    >
      <></>
    </HeroBanner>
  );
};
